import { useState, useEffect } from 'react'
import { EMAIL_VERIFICATION_QA_CHANGE_EVENT } from '../emailVerificationQA'

// Reads a QA-panel setting via `getter` and re-reads it whenever QA state
// changes, so a screen that's already on display updates live (no reload).
export default function useEmailVerificationQASetting(getter) {
  const [value, setValue] = useState(getter)
  useEffect(() => {
    const handleChange = () => setValue(getter())
    window.addEventListener(EMAIL_VERIFICATION_QA_CHANGE_EVENT, handleChange)
    return () => window.removeEventListener(EMAIL_VERIFICATION_QA_CHANGE_EVENT, handleChange)
  }, [getter])
  return value
}
